export const RATE_UNITS = ["per uur", "per half uur", "per sessie", "per nacht"];
export const GENDERS = ["Vrouw", "Man", "Trans", "Koppel"];
export const FOR_WHOM = ["Mannen", "Vrouwen", "Koppels", "Iedereen"];

export const isService = (p) => p?.listing_type === "service";
export const listingPath = (p) => `/${isService(p) ? "dienst" : "product"}/${p.id}`;
export const formatRate = (p) => `€ ${Number(p.price).toFixed(2)}${p.rate_unit ? ` ${p.rate_unit}` : ""}`;

export const DAYS = ["Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag", "Zondag"];
